export enum TaxObligationStatus {
    OVERDUE = 'OVERDUE',
    DUE_SOON = 'DUE_SOON',
    SCHEDULED = 'SCHEDULED',
    COMPLETED = 'COMPLETED'
}
